import { useInterviewContext } from "../InterviewContext";
import OtherLanguageSection from "./OtherLanguageSection";
import TechnicalSkillsSection from "./TechnicalSkillsSection";
import { useTranslation } from "react-i18next";
import "../../styles/forms.scss";
import TechSkillQuiz from "../Quiz/TechSkillQuiz";
import Select from "../../../components/Select";
import PersonalSkills from "./PersonalSkills";

const PersonalTechSkills = () => {
  const { t } = useTranslation();
  const {
    interview,
    setInterview,
    languageList,
    languageLevelList
  } = useInterviewContext();

  const addAnotherLanguage = () => {
    if (interview.otherLanguages.length > 0) {
      if (Object.keys(interview.otherLanguages.at(-1)).length > 0) {
        setInterview((prevInterview) => ({
          ...prevInterview,
          otherLanguages: [...prevInterview.otherLanguages, {}]
        }));
      }
    } else {
      setInterview((prevInterview) => ({
        ...prevInterview,
        otherLanguages: [{}]
      }));
    }
  };

  const deleteAnotherLanguage = (index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      otherLanguages: prevInterview.otherLanguages.filter(
        (item, i) => i !== index
      )
    }));
  };

  const onChange = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      [`${event.target.name}`]: event.target.value
    }));
  };

  const onChangeNativeLanguage = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      motherLanguageId: Number(event.target.value)
    }));
  };

  function buttonAddLanguage() {
    if(interview.otherLanguages.length === 0){
      return "";
    }else{
      return "position-button-add-language";
    }
  }

  const handleOtherSkillsChange = (event) => {
  setInterview((prev) => ({
    ...prev,
    otherSkills: event.target.value
  }));
};

  return (
    <>
      <div className="row skill-language-width">
        <div className="col-2">
          <div className="form-group">
            <h1>{t("Native Language")}</h1>
            <Select
              className="form-select"
              name="motherLanguageId"
              onChange={onChangeNativeLanguage}
              value={interview.motherLanguageId}
              title={t("Selecione um item da lista.")}
            >
              {languageList.map((lang) => (
                <option key={lang.id} value={lang.id}>
                  {t(lang.description)}
                </option>
              ))}
            </Select>
          </div>
        </div>
      </div>
      <h4 style={{ marginTop: "15px" }}>{t("Other Languages")}</h4>
      {interview.otherLanguages.map((otherLang, index) => (
        <OtherLanguageSection
          otherLanguage={otherLang}
          languageList={languageList}
          languageLevelList={languageLevelList}
          deleteAnotherLanguage={deleteAnotherLanguage}
          index={index}
        />
      ))}
      <div className="col-6">
        <button 
          className={`app-button btn-prime btn-lg ${buttonAddLanguage()}`} 
          onClick={addAnotherLanguage}
          type="button"
        >
          {t("Add another language")}
        </button>
      </div>
      <PersonalSkills interview={interview} setInterview={setInterview} />
      <div className="row mt-3">
        <div className="col-6">
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Other Skill Competences")}</label>
            </div>
            <textarea
              rows="6"
              name="otherSkill"
              onChange={handleOtherSkillsChange}
              value={interview.otherSkills}
              placeholder={t("Description...")}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Skill evaluation")}</label>
            </div>
            <textarea
              rows="6"
              name="skillEvaluation"
              onChange={onChange}
              value={interview.skillEvaluation}
              placeholder={t("Description...")}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default PersonalTechSkills;
